import React from 'react'
import OrderList from '../../features/admin/OrderList'

const OrderListPage = () => {
  return <OrderList/>
}

export default OrderListPage